const messages = {
  pt: {
    translations: {
      signup: {
        title: "Cadastre-se",
        toasts: {
          success: "Usuário criado com sucesso! Faça seu login!!!.",
          fail: "Erro ao criar usuário. Verifique os dados informados.",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
        },
        buttons: {
          submit: "Cadastrar",
          login: "Já tem uma conta? Entre!",
        },
      },
      login: {
        title: "Login",
        form: {
          email: "Email",
          password: "Senha",
        },
        buttons: {
          submit: "Entrar",
          register: "Não tem um conta? Cadastre-se!",
        },
      },
      auth: {
        toasts: {
          success: "Login efetuado com sucesso!",
        },
      },
      dashboard: {
        charts: {
          perDay: {
            title: "Chats hoje: ",
          },
        },
        messages: {
          inAttendance: {
            title: "Em Atendimento"
          },
          waiting: {
            title: "Aguardando"
          },
          closed: {
            title: "Finalizado"
          }
        },
      },
      connections: {
        title: "Conexões",
        usage: {
          active: "Ativa",
          inactive: "Inativa",
        },
        toasts: {
          deleted: "Conexão com o WhatsApp excluída com sucesso!",
        },
        confirmationModal: {
          deleteTitle: "Deletar",
          deleteMessage: "Você tem certeza? Essa ação não pode ser revertida.",
          disconnectTitle: "Desconectar",
          disconnectMessage:
            "Tem certeza? Você precisará ler o QR Code novamente.",
          activateTitle: "Ativar conexão",
          activateMessage:
            "Se seu plano ja atingiu o limite de conexoes ativas, outra conexao sera desvinculada para liberar espaco.",
        },
        buttons: {
          add: "Adicionar WhatsApp",
          disconnect: "desconectar",
          tryAgain: "Tentar novamente",
          qrcode: "QR CODE",
          newQr: "Novo QR CODE",
          connecting: "Conectando",
        },
        toolTips: {
          disconnected: {
            title: "Falha ao iniciar sessão do WhatsApp",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e tente novamente, ou solicite um novo QR Code",
          },
          qrcode: {
            title: "Esperando leitura do QR Code",
            content:
              "Clique no botão 'QR CODE' e leia o QR Code com o seu celular para iniciar a sessão",
          },
          connected: {
            title: "Conexão estabelecida!",
          },
          timeout: {
            title: "A conexão com o celular foi perdida",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e o WhatsApp esteja aberto, ou clique no botão 'Desconectar' para obter um novo QR Code",
          },
        },
        table: {
          platform: "Plataforma",
          name: "Nome",
          connection: "Conexão",
          status: "Status",
          usage: "Uso",
          lastUpdate: "Última atualização",
          default: "Padrão",
          actions: "Ações",
          session: "Sessão",
        },
      },
      connectionModal: {
        title: {
          add: "Adicionar WhatsApp",
          edit: "Editar WhatsApp",
        },
        form: {
          name: "Nome",
          default: "Padrão",
          timeZone: "Fuso horário",
          serverTimeZone: "Usar fuso horário do servidor",
          queueRedirectEnabled: "Redirecionamento para áreas",
          farewellMessage: "Mensagem de despedida"
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "WhatsApp salvo com sucesso.",
      },
      qrCode: {
        message: "Leia o QrCode para iniciar a sessão",
      },
      contacts: {
        title: "Contatos",
        toasts: {
          deleted: "Contato excluído com sucesso!",
        },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: {
          deleteTitle: "Deletar ",
          importTitlte: "Importar contatos",
          deleteMessage:
            "Tem certeza que deseja deletar este contato? Todos os chats relacionados serão perdidos.",
          importMessage: "Deseja importas todos os contatos do telefone?",
        },
        buttons: {
          import: "Importar Contatos",
          add: "Adicionar Contato",
        },
        table: {
          name: "Nome",
          connection: "Conexão",
          email: "Email",
          actions: "Ações",
        },
      },
      contactModal: {
        title: {
          add: "Adicionar contato",
          edit: "Editar contato",
        },
        form: {
          mainInfo: "Dados do contato",
          extraInfo: "Informações adicionais",
          name: "Nome",
          number: "Número do Whatsapp",
          email: "Email",
          extraName: "Nome do campo",
          extraValue: "Valor",
        },
        buttons: {
          addExtraInfo: "Adicionar informação",
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Contato salvo com sucesso.",
      },
      quickAnswersModal: {
        title: {
          add: "Adicionar Resposta Rápida",
          edit: "Editar Resposta Rápida",
        },
        form: {
          shortcut: "Atalho",
          category: "Categoria",
          actionType: "Acao",
          sequence: "Sequencia",
          message: "Resposta Rápida",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Resposta Rápida salva com sucesso.",
      },
      chatbotModal: {
        title: { add: "Adicionar sequência", edit: "Editar sequência" },
        sections: { schedule: "Condição de horários", chatbot: "Chatbot", quickReply: "Resposta rápida", execution: "Pausa / Execuções", transfer: "Transferir", labels: "Etiquetas", ai: "IA", blocks: "Mensagens" },
        form: {
          name: "Nome", category: "Categoria", parent: "Sequência pai", noParent: "Sem pai",
          matchType: "Tipo de coincidência", requireAllTriggers: "Exigir todos os gatilhos", trigger: "Gatilhos", triggerHelp: "Use uma quebra de linha por gatilho.", conditionalTriggerHelp: "Use uma linha por condição e vírgulas para variações.",
          active: "Ativa", quickReplyEnabled: "Ativar resposta rápida", quickReplyMatchType: "Tipo de coincidência", quickReplyTrigger: "Gatilhos de resposta rápida", scheduleEnabled: "Restringir execução por horários",
          startTime: "Hora inicial", endTime: "Hora final",
          outOfHoursSequence: "Sequência fora do horário", noOutOfHoursSequence: "Não executar outra sequência",
          executionMode: "Modo de execução",
          executionLimit: "Quantidade", executionInterval: "Tempo", executionIntervalUnit: "Temporalidade",
          transferType: "Transferir", transferQueue: "Área", transferUser: "Usuário", noTransferAutoAssignQueues: "Sem área", noTransferAutoAssignUsers: "Sem usuário", transferAutoAssignRequired: "Selecione pelo menos uma área ou usuário para ativar a distribuição.", addLabels: "Adicionar etiquetas", removeLabels: "Remover etiquetas", aiAction: "Ação de IA", chatbotAction: "Ação de Chatbot", aiInitialMessage: "Mensagem inicial simulada do cliente", aiPrompt: "Prompt personalizado",
          message: "Mensagem", delay: "Espera de", noFile: "Sem arquivo", inactivityMessage: "Mensagem de inatividade", inactivityValue: "Tempo", inactivityUnit: "Intervalo", inactivitySequence: "Sequencia a executar", noInactivitySequence: "Nao executar sequencia",
        },
        matchTypes: { exact: "Exata", contains: "Contém", conditional: "Condicional", anything: "Qualquer coisa", newChat: "Novo chat" },
        executionModes: { unlimited: "Sem limite", executionCount: "Por número de execuções", timeWindow: "Por tempo decorrido" },
        transferTypes: { none: "Não transferir", queue: "Para área", user: "Para usuário", both: "Para área e usuário", auto: "Autoatribuição", resolve: "Resolver" },
        aiActions: { none: "Não alterar IA", activate: "Ativar IA", activateReset: "Ativar e resetar IA", deactivate: "Desligar IA", deactivateReset: "Desligar e resetar IA" },
        chatbotActions: { none: "Não alterar", activate: "Ativar", activateReset: "Ativar e resetar", deactivate: "Desligar", deactivateReset: "Desligar e resetar" },
        units: { seconds: "Segundos", minutes: "Minutos", hours: "Horas", days: "Dias", months: "Meses" },
        buttons: { okAdd: "Adicionar", okEdit: "Salvar", cancel: "Cancelar", file: "Selecionar arquivo", removeFile: "Remover", addBlock: "Adicionar mensagem", addInactivityBlock: "Adicionar mensagem de inatividade" },
        success: "Sequência salva com sucesso.",
      },
      queueModal: {
        title: {
          add: "Adicionar área",
          edit: "Editar área",
        },
        form: {
          name: "Nome",
          color: "Cor",
          greetingMessage: "Mensagem de saudação",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Área salva com sucesso.",
      },
      userModal: {
        title: {
          add: "Adicionar usuário",
          edit: "Editar usuário",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
          profile: "Perfil",
          connection: "Conexão Padrão",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Usuário salvo com sucesso.",
      },
      chat: {
        noTicketMessage: "Selecione um chat para começar a conversar.",
      },
      ticketsManager: {
        buttons: {
          newTicket: "Novo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Áreas",
      },
      tickets: {
        toasts: {
          deleted: "O chat que você estava foi deletado.",
        },
        notification: {
          message: "Mensagem de",
        },
        tabs: {
          open: { title: "Inbox" },
          closed: { title: "Resolvidos" },
          search: { title: "Busca" },
        },
        search: {
          placeholder: "Buscar chats e mensagens",
        },
        buttons: {
          showAll: "Todos",
        },
        chatFilters: {
          all: "Todos",
          groups: "Grupos",
          contacts: "Pessoas",
          unread: "Nao lidos",
        },
      },
      transferTicketModal: {
        title: "Transferir chat",
        fieldLabel: "Digite para buscar usuários",
        fieldQueueLabel: "Transferir para área",
        fieldConnectionLabel: "Transferir para conexão",
        fieldQueuePlaceholder: "Selecione uma área",
        fieldConnectionPlaceholder: "Selecione uma conexão",
        noOptions: "Nenhum usuário encontrado com esse nome",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      ticketsList: {
        pendingHeader: "Aguardando",
        assignedHeader: "Atendendo",
        noTicketsTitle: "Nada aqui!",
        noTicketsMessage:
          "Nenhum chat encontrado com esse status ou termo pesquisado",
        connectionTitle: "Conexão que está sendo utilizada atualmente.",
        agentTitle: "Agente atendendo este chat.",
        buttons: {
          accept: "Aceitar",
        },
      },
      newTicketModal: {
        title: "Criar chat",
        fieldLabel: "Digite para pesquisar o contato",
        add: "Adicionar",
        buttons: {
          ok: "Salvar",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Conexões",
          tickets: "Chats",
          contacts: "Contatos",
          quickAnswers: "Respostas Rápidas",
          reminders: "Lembretes",
          agenda: "Agenda",
          orders: "Pedidos",
          campaigns: "Campanhas",
          internalChat: "Chat Interno",
          funnels: "Funis",
          chatbot: "Chatbot",
          ai: "IA",
          queues: "Áreas",
          administration: "Administração",
          users: "Usuários",
          settings: "Configurações",
          labels: "Etiquetas",
        },
        appBar: {
          user: {
            profile: "Perfil",
            logout: "Sair",
          },
        },
      },
      notifications: {
        noTickets: "Nenhuma notificação.",
      },
      queues: {
        title: "Áreas",
        table: {
          name: "Nome",
          color: "Cor",
          greeting: "Mensagem de saudação",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar área",
        },
        toasts: {
          deleted: "Área excluida com sucesso.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Você tem certeza? Essa ação não pode ser revertida! Os chats dessa área continuarão existindo, mas não terão mais nenhuma área atribuída.",
        },
      },
      queueSelect: {
        inputLabel: "Áreas",
      },
      ticketLabels: {
        inputLabel: "Etiquetas",
        placeholder: "Adicionar etiquetas",
        filterLabel: "Etiquetas",
      },
      labels: {
        title: "Etiquetas",
        table: { name: "Nome", color: "Cor", actions: "Ações" },
        buttons: { add: "Adicionar etiqueta" },
        toasts: { deleted: "Etiqueta excluída com sucesso" },
        confirmationModal: {
          deleteTitle: "Excluir etiqueta",
          deleteMessage: "Esta ação não pode ser desfeita.",
        },
      },
      labelModal: {
        title: { add: "Adicionar etiqueta", edit: "Editar etiqueta" },
        form: { name: "Nome", color: "Cor" },
        buttons: { okAdd: "Adicionar", okEdit: "Salvar", cancel: "Cancelar" },
        success: "Etiqueta salva com sucesso.",
      },
      quickAnswers: {
        title: "Respostas Rápidas",
        table: {
          shortcut: "Atalho",
          category: "Categoria",
          message: "Resposta Rápida",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar Resposta Rápida",
        },
        toasts: {
          deleted: "Resposta Rápida excluída com sucesso.",
        },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: {
          deleteTitle:
            "Você tem certeza que quer excluir esta Resposta Rápida: ",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
      },
      agendaPage: {
        title: "Agenda",
      },
      remindersPage: {
        title: "Lembretes",
        form: {
          contact: "Contato",
        },
        table: {
          contact: "Contato",
          connection: "Conexão",
          date: "Data e hora",
          status: "Status",
          message: "Mensagem",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar lembrete",
        },
        validation: {
          contact: "Selecione um contato.",
        },
        empty: "Nenhum lembrete programado.",
      },
      internalChat: {
        title: "Chat Interno",
        empty: "Crie ou selecione um chat interno para comecar.",
        inputPlaceholder: "Escreva uma mensagem",
        buttons: {
          new: "Novo",
          cancel: "Cancelar",
          create: "Criar",
          save: "Salvar",
        },
        create: {
          title: "Criar chat interno",
          name: "Nome do Chat Interno",
          users: "Usuarios",
        },
        edit: {
          title: "Editar chat interno",
        },
      },
      chatbot: {
        title: "Chatbot",
        table: { name: "Sequência", category: "Categoria", parent: "Pai", matchType: "Coincidência", blocks: "Mensagens", status: "Status", actions: "Ações" },
        status: { active: "Ativa", inactive: "Inativa" },
        buttons: { add: "Adicionar sequência" },
        toasts: { deleted: "Sequência excluída com sucesso." },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: { deleteTitle: "Excluir esta sequência?", deleteMessage: "Esta ação não pode ser revertida." },
      },
      ai: {
        title: "IA",
        form: { active: "Ativar IA", apiKey: "API Key da OpenAI", model: "Modelo de IA", skipMarkAsRead: "Nao marcar como lido ao responder", waitModeEnabled: "Modo espera", waitModeSeconds: "Tempo de espera em segundos", applyConversationContext: "Aplicar contexto da conversa", conversationContextMessages: "Mensagens de contexto", prompt: "Prompt" },
        buttons: { save: "Salvar" },
        toasts: { saved: "ConfiguraÃ§Ã£o de IA salva corretamente." },
      },
      users: {
        title: "Usuários",
        table: {
          name: "Nome",
          email: "Email",
          profile: "Perfil",
          connection: "Conexão Padrão",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar usuário",
        },
        toasts: {
          deleted: "Usuário excluído com sucesso.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Todos os dados do usuário serão perdidos. Os chats abertos deste usuário serão movidos para a área.",
        },
      },
      superAdmin: {
        title: "Contas SaaS",
        sections: {
          users: "Usuarios",
          connections: "Conexoes",
        },
        table: {
          name: "Nome",
          email: "Email",
          profile: "Perfil",
          status: "Status",
          connection: "Conexão",
          default: "Padrao",
          actions: "Acoes",
        },
        form: {
          expiresAt: "Data de expiracao",
          maxUsers: "Limite de usuarios",
          maxConnections: "Limite de conexoes",
        },
        actionTypes: {
          message: "Mensagem",
          sequence: "Sequencia",
        },
        buttons: {
          refresh: "Atualizar",
          enter: "Entrar",
          saveExpiration: "Salvar expiracao",
          clearExpiration: "Sem expiracao",
          saveSettings: "Salvar limites",
          clearLimits: "Sem limites",
          delete: "Excluir",
          reset: "Limpar conta",
        },
        values: {
          yes: "Sim",
          no: "Nao",
          active: "Ativa",
          expired: "Expirada",
        },
        toasts: {
          expirationSaved: "Data de expiracao salva.",
          settingsSaved: "Configuracao da conta salva.",
          deleted: "Conta excluida com sucesso.",
          reset: "Conta limpa com sucesso.",
        },
        confirmationModal: {
          deleteTitle: "Excluir conta",
          deleteMessage:
            "Esta acao excluira a conta SaaS e todos os seus usuarios, conexoes, contatos, chats e configuracoes. Esta acao nao pode ser desfeita.",
          resetTitle: "Limpar conta",
          resetMessage:
            "Esta acao excluira usuarios secundarios, conexoes, contatos, chats, automacoes e configuracoes desta conta. Apenas o usuario admin principal sera mantido. Esta acao nao pode ser desfeita.",
        },
        empty: {
          accounts: "Nenhuma conta encontrada.",
          connections: "Esta conta nao tem conexoes.",
        },
      },
      settings: {
        success: "Configurações salvas com sucesso.",
        title: "Configurações",
        settings: {
          userCreation: {
            name: "Criação de usuário",
            options: {
              enabled: "Ativado",
              disabled: "Desativado",
            },
          },
          dashboardWebChatScript: {
            name: "Script do WebChat no dashboard",
            helper:
              "Cole o snippet do WebChat. Ele será carregado para usuários logados e usará nome e email.",
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Atribuído à:",
          buttons: {
            return: "Retornar",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceitar",
          },
        },
      },
      messagesInput: {
        placeholderOpen: "Digite uma mensagem ou tecle ''/'' para utilizar as respostas rápidas cadastrada",
        placeholderClosed:
          "Reabra ou aceite esse chat para enviar uma mensagem.",
        signMessage: "Assinar",
      },
      contactDrawer: {
        header: "Dados do contato",
        buttons: {
          edit: "Editar contato",
        },
        whatsapp: {
          invalid:
            "Este numero nao tem WhatsApp. Voce pode mante-lo como dado do cliente, mas mensagens de WhatsApp nao poderao ser enviadas para este numero.",
          pending:
            "Este numero ainda nao foi verificado no WhatsApp. Voce pode mante-lo como dado do cliente; ele sera verificado novamente ao enviar.",
        },
        extraInfo: "Outras informações",
      },
      ticketOptionsMenu: {
        clearChat: "Esvaziar chat",
        clearChatSuccess: "Chat esvaziado com sucesso.",
        delete: "Deletar",
        transfer: "Transferir",
        ai: "IA",
        chatbot: "Chatbot",
        reminders: "Lembretes",
        notes: "Notas",
        syncMessages: "Sincronizar mensagens",
        syncSuccess: "{{count}} mensagem(ns) sincronizada(s).",
        syncSettingsSaved: "Configuracao de sincronizacao salva.",
        syncModal: {
          title: "Sincronizar mensagens",
          autoSyncLabel: "Sincronizar automaticamente ao criar o chat",
          description:
            "Quando ativo, mensagens recebidas que criam um novo chat tentam carregar mensagens anteriores automaticamente. Se desativado, voce pode sincronizar manualmente aqui.",
          syncNow: "Sincronizar agora",
          save: "Salvar",
        },
        confirmationModal: {
          title: "Deletar o chat do contato",
          message:
            "Atenção! Todas as mensagens relacionadas ao chat serão perdidas.",
        },
        clearChatConfirmationModal: {
          title: "Esvaziar chat #",
          titleFrom: "do contato ",
          message:
            "Atencao! Todas as mensagens deste chat serao apagadas, mas o chat sera mantido.",
        },
        buttons: {
          delete: "Excluir",
          cancel: "Cancelar",
        },
      },
      ticketAiModal: {
        title: "IA do chat",
        status: {
          active: "A IA esta ativa neste chat.",
          inactive: "A IA esta desligada neste chat.",
        },
        buttons: {
          activate: "Ativar IA",
          deactivate: "Desligar IA",
          deactivateReset: "Desligar e resetar",
          close: "Fechar",
        },
        toasts: {
          activate: "IA ativada neste chat.",
          deactivate: "IA desligada neste chat.",
          deactivateReset: "IA desligada e resetada neste chat.",
        },
        confirmationModal: {
          title: "Desligar e resetar IA",
          message:
            "Tem certeza? O fio de conversa da IA deste chat sera eliminado.",
        },
      },
      ticketChatbotModal: {
        title: "Chatbot do chat",
        status: {
          active: "O chatbot esta ativo neste chat.",
          inactive: "O chatbot esta desligado neste chat.",
        },
        buttons: {
          activate: "Ativar Chatbot",
          activateReset: "Ativar e Resetar Chatbot",
          deactivate: "Desligar Chatbot",
          deactivateReset: "Desligar e Resetar Chatbot",
          close: "Fechar",
        },
        toasts: {
          activate: "Chatbot ativado neste chat.",
          activateReset: "Chatbot ativado e resetado neste chat.",
          deactivate: "Chatbot desligado neste chat.",
          deactivateReset: "Chatbot desligado e resetado neste chat.",
        },
        confirmationModal: {
          activateReset: {
            title: "Ativar e resetar chatbot",
            message:
              "A hierarquia atual, execucoes e pausas pendentes serao limpas antes de ativar o chatbot.",
          },
          deactivateReset: {
            title: "Desligar e resetar chatbot",
            message:
              "A hierarquia atual, execucoes e pausas pendentes serao limpas, e o chatbot ficara desligado.",
          },
        },
      },
      ticketNotesModal: {
        title: "Notas",
        empty: "Este chat nao tem notas internas.",
        buttons: {
          close: "Fechar",
        },
      },
      ticketRemindersModal: {
        title: "Lembretes",
        empty: "Este contato nao tem lembretes.",
        form: {
          title: "Titulo",
          actionType: "Acao",
          date: "Data",
          time: "Hora",
          recurrenceValue: "Repetir a cada",
          recurrenceUnit: "Unidade",
          sequence: "Sequencia",
          message: "Mensagem",
          delay: "Espera de",
          noFile: "Sem arquivo",
        },
        actionTypes: {
          message: "Mensagem",
          sequence: "Sequencia",
        },
        recurrenceUnits: {
          none: "Sem recorrencia",
          seconds: "Segundos",
          minutes: "Minutos",
          hours: "Horas",
          days: "Dias",
          weeks: "Semanas",
          months: "Meses",
        },
        status: {
          pending: "Pendente",
          processing: "Processando",
          completed: "Concluido",
          failed: "Falhou",
          cancelled: "Cancelado",
        },
        values: {
          untitled: "Lembrete sem titulo",
          completed: "Concluido",
        },
        buttons: {
          add: "Novo lembrete",
          save: "Salvar",
          cancel: "Cancelar",
          close: "Fechar",
          file: "Selecionar arquivo",
          removeFile: "Remover",
          addBlock: "Adicionar mensagem",
        },
        toasts: {
          saved: "Lembrete salvo com sucesso.",
          deleted: "Lembrete excluido com sucesso.",
        },
        validation: {
          datetime: "Selecione data e hora.",
          recurrence: "Informe a frequencia de repeticao.",
          sequence: "Selecione uma sequencia.",
          message: "Adicione pelo menos uma mensagem ou arquivo.",
        },
        confirmationModal: {
          deleteTitle: "Excluir lembrete",
          deleteMessage: "Esta acao nao pode ser desfeita.",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageOptionsMenu: {
        delete: "Deletar",
        reply: "Responder",
        confirmationModal: {
          title: "Apagar mensagem?",
          message: "Esta ação não pode ser revertida.",
        },
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP: "Deve haver pelo menos um WhatsApp padrão.",
        ERR_NO_DEF_WAPP_FOUND:
          "Nenhum WhatsApp padrão encontrado. Verifique a página de conexões.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sessão do WhatsApp não foi inicializada. Verifique a página de conexões.",
        ERR_WAPP_CHECK_CONTACT:
          "Não foi possível verificar o contato do WhatsApp. Verifique a página de conexões",
        ERR_WAPP_INVALID_CONTACT: "Este não é um número de Whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Não foi possível baixar mídia do WhatsApp. Verifique a página de conexões.",
        ERR_INVALID_CREDENTIALS:
          "Erro de autenticação. Por favor, tente novamente.",
        ERR_SENDING_WAPP_MSG:
          "Erro ao enviar mensagem do WhatsApp. Verifique a página de conexões.",
        ERR_SENDING_CHANNEL_MSG:
          "Erro ao enviar mensagem pelo canal. Verifique a conexão e reautorize se necessário.",
        ERR_TICKET_NO_CHANNEL:
          "O ticket não possui uma conexão associada.",
        ERR_DELETE_WAPP_MSG: "Não foi possível excluir a mensagem do WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Já existe um tíquete aberto para este contato.",
        ERR_SESSION_EXPIRED: "Sessão expirada. Por favor entre.",
        ERR_USER_CREATION_DISABLED:
          "A criação do usuário foi desabilitada pelo administrador.",
        ERR_NO_PERMISSION: "Você não tem permissão para acessar este recurso.",
        ERR_COMPANY_WHATSAPP_SESSIONS_LIMIT_REACHED:
          "Seu plano atingiu o limite de conexoes ativas. Para usar esta conexao, desconecte uma conexao ativa ou contrate uma conexao adicional.",
        ERR_DUPLICATED_CONTACT: "Já existe um contato com este número.",
        ERR_NO_SETTING_FOUND: "Nenhuma configuração encontrada com este ID.",
        ERR_INVALID_AI_CREDIT_LIMIT:
          "O limite de creditos de IA incluida deve ser um numero maior ou igual a zero.",
        ERR_INVALID_AI_CREDIT_USAGE:
          "O consumo de creditos de IA incluida deve ser um numero maior ou igual a zero.",
        ERR_AI_INCLUDED_CREDITS_EXCEEDED:
          "A conta atingiu o limite de creditos de IA incluida.",
        ERR_NO_CONTACT_FOUND: "Nenhum contato encontrado com este ID.",
        ERR_NO_TICKET_FOUND: "Nenhum tíquete encontrado com este ID.",
        ERR_NO_USER_FOUND: "Nenhum usuário encontrado com este ID.",
        ERR_NO_WAPP_FOUND: "Nenhum WhatsApp encontrado com este ID.",
        ERR_CREATING_MESSAGE: "Erro ao criar mensagem no banco de dados.",
        ERR_CREATING_TICKET: "Erro ao criar tíquete no banco de dados.",
        ERR_FETCH_WAPP_MSG:
          "Erro ao buscar a mensagem no WhtasApp, talvez ela seja muito antiga.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Esta cor já está em uso, escolha outra.",
        ERR_WAPP_GREETING_REQUIRED:
          "A mensagem de saudação é obrigatório quando há mais de uma área.",
      },
    },
  },
};

export { messages };

